import axios from '@/utils/request';

// 获取系统公告
export const getAnnounces = (data: any) => {
  return axios.request({
    url: 'Connect/GetAnnounces',
    method: 'GET',
    params: data,
  });
};

// 获取我的消息
export const getNotices = (data: any) => {
  return axios.request({
    url: 'Connect/GetNotices',
    method: 'GET',
    params: data,
  });
};
